import {observable, action, computed, transaction, toJS} from "mobx";
import BaseItemStore from "@vidazoo/ui-framework/lib/stores/BaseItemStore";

export default class ProfileStore extends BaseItemStore<any> {
	@observable public avatarUrl: string;
	@observable public isOpen: boolean;
	@observable public dataUrl: string;
	@observable public item = {};

	constructor(notificationsStore) {
		super(notificationsStore, "profile");
		this.reset();
	}

	@action
	public reset() {
		return;
	}

	@action public open = () => {
		this.isOpen = true;
		this.getItem();
	};

	@action public close = () => {
		this.isOpen = false;
		this.reset();
	};

	@action
	public getItem() {
		return;
	}

	@action
	public setItem(data) {
		return;
	}

	@action
	public submit() {
		return;
	}

	@action private onCreateTokenApiSuccess = (tokenApi: string) => {
		return;
	};

	@action public clearNewToken = () => {
		return;
	};

	@action public getTokensApi = () => {
		return;
	};

	@action private onGetTokensApiSuccess = (res) => {
		return;
	};

	@action public deleteToken = (tokenId: string) => {
		return;
	};

	@action public genereateTwoFactorSecret = (password: string) => {
		return;
	};

	@action private setDataUrl = (url) => {
		this.dataUrl = url;
	};

	@action public disableTwoFactorAuth = (password: string) => {
		return;
	};

	@action public enableTwoFactoAuth = (token: string) => {
		return;
	};

	@action public updatePassword = (currentPassword: string, newPassword: string) => {
		return;
	};

	@action public checkPassword = (password: string) => {
		return true;
	};

	@computed get isCheckingPassword(): boolean {
		return;
	}

	@computed get passwordScore(): number {
		return;
	}
}
